var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import styled from 'styled-components';
import { Spin, Dropdown } from 'antd';
import { Icon } from '../components/Icon';
import ThemeProvider from './ThemeProvider';
const Widget = _ref => {
  let {
    height,
    children,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(WidgetContainer, {
    height: height,
    style: style
  }, /*#__PURE__*/React.createElement(InnerContainer, null, children)));
};
const Content = _ref2 => {
  let {
    loading,
    children,
    style
  } = _ref2;
  return /*#__PURE__*/React.createElement(WidgetContentContainer, null, /*#__PURE__*/React.createElement(WidgetContent, {
    style: style
  }, !loading && children, loading && /*#__PURE__*/React.createElement(Spinner, null, /*#__PURE__*/React.createElement(Spin, {
    size: "large"
  }))));
};
const MenuButton = _ref3 => {
  let {
    items,
    style,
    onMenuItemClick
  } = _ref3;
  return /*#__PURE__*/React.createElement(Dropdown, {
    menu: {
      items,
      onClick: onMenuItemClick
    },
    placement: "bottomRight",
    trigger: ['click']
  }, /*#__PURE__*/React.createElement(MenuButtonContainer, {
    style: style
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "ellipsis-v"
  })));
};
const WidgetContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  margin-bottom: 24px;\n  background-color: #fff;\n  overflow: hidden;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  box-shadow: 4px 4px 25px rgba(0 0 0 / 10%);\n"])), p => p.height + 'px');
const InnerContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 100%;\n  color: #333;\n  overflow: hidden;\n"])));
const Header = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 40px;\n  line-height: 20px;\n  padding: 10px 10px 10px 15px;\n  background-color: #fff;\n  font-size: 16px;\n  box-sizing: border-box;\n  position: relative;\n  font-weight: bold;\n\n"])));
const WidgetContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 100%;\n  overflow-y: auto;\n"])));
const WidgetContentContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 100%;\n  padding-bottom: 40px;\n  overflow: hidden;  \n"])));
const Spinner = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n"])));
const MenuButtonContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\nposition: absolute;\nright: 10px;\ntop: 10px;\n  color: #666;\n  font-size: 16px;\n  font-weight: normal;\n  padding: 0 5px;\n  cursor: pointer;\n  &:hover {\n    color: #333;\n  }\n"])));
Widget.Header = Header;
Widget.Content = Content;
Widget.MenuButton = MenuButton;
export default Widget;